var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"base-cell",class:_vm.customClass},Object.assign({}, _vm.$listeners, _vm.hoverHandlers)),[_vm._t("default",null,{"hover":_vm.isHover})],2)}
var staticRenderFns = []

export { render, staticRenderFns }